// Converts cents to dollars
export default function centsToDollars(value?: number) {
  return (value || 0) / 100
}
